/**
 * The Items-tab -> New-box selection handoff key. Its own module, not an export of
 * `screens/boxes.tsx`, for a bundling reason that cost a CI failure: the boxes screens
 * are LAZY (a separate chunk, because 0.1.164 pushed the entry bundle 6.8 kB over its
 * 500 kB ceiling), and a static import of anything in that file from bulk-edit would
 * pull the whole chunk straight back into the entry.
 *
 * sessionStorage rather than the URL: a hundred uuids is not a URL. The create screen
 * clears it on save.
 */
export const NEW_BOX_ITEMS_KEY = 'mononoke:new-box-items';
